import { render, staticRenderFns } from "./courses-list.vue?vue&type=template&id=45778e44&scoped=true"
import script from "./courses-list.vue?vue&type=script&lang=js"
export * from "./courses-list.vue?vue&type=script&lang=js"
import style0 from "./courses-list.vue?vue&type=style&index=0&id=45778e44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45778e44",
  null
  
)

export default component.exports